(function() {
    var $adWrap = $('.sr-up-download-wrap');
    var $ad = $('.sr-up-download');
    var $closeBtn = $ad.find('.J_closeDownload');

    if (location.search.indexOf('channel=share') !== -1) {
        $adWrap.show();
    }

    $closeBtn.on('click', function() {
        destroyAD();
    });

    SR.dom.$scrollWrap.on('touchmove.ad', function() {
        destroyAD();
    });

    function destroyAD() {
        $ad.slideUp(150, function() {
            $adWrap.remove();
            SR.dom.$scrollWrap.off('touchmove.ad');
        });
    }
})();